export const MODULE_PATH = "control"

export const CONTROL_MAP = `/s/${MODULE_PATH}/map`

export const CONTROL_MAP_OWNERS = `/s/${MODULE_PATH}/owners`

export const GEOFENCES_LIST = `/s/${MODULE_PATH}/geofences/list`
export const GEOFENCE_DETAIL = `/s/${MODULE_PATH}/geofences/visualization`
export const GEOFENCE_FORM = `/s/${MODULE_PATH}/geofences/form`